import axios from 'axios';

const BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.emailverifier.msdiscoveries.com/api'
    : 'http://localhost:3001/api');

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 60000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    // Don't override Content-Type for multipart (file uploads)
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (!err.response) {
      console.error('🔴 Network/CORS error:', err.message, '| URL:', BASE_URL);
      return Promise.reject(new Error('Cannot connect to server. Check if the backend is running and CORS is configured.'));
    }
    if (err.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    } else if (err.response.status === 403) {
      const msg = (err.response?.data?.message || '').toLowerCase();
      if (msg.includes('token') || msg.includes('expired')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
